<style>
  .section {
    margin-top: 20px;
    border-top: 1px solid #dddddd;
    padding-top: 20px;
  }

  table {
    width: 100%;
  }
  table tr td {
    padding-right: 10px;
    padding-left: 10px;
  }
  table tr td:first-child {
    padding-left: 0px;
  }
  table tr td:last-child {
    padding-right: 0px;
    width: 50%;
  }
</style>

<div style="width: 1200px">
  <h1>CPO Styles, Guidelines, and Examples</h1>

  <div style="margin-bottom: 50px">
    <input
      type="button"
      class="button_primary button_var_1 button_right-spacing"
      value="Typography"
      (click)="jumpToSection('divTypography')"
    />
    <input
      type="button"
      class="button_primary button_var_1 button_right-spacing"
      value="Colors"
      (click)="jumpToSection('divColors')"
    />
    <input
      type="button"
      class="button_primary button_var_1 button_right-spacing"
      value="Iconography"
      (click)="jumpToSection('divIconography')"
    />
    <input
      type="button"
      class="button_primary button_var_1 button_right-spacing"
      value="Loading Spinners"
      (click)="jumpToSection('divLoadingSpinners')"
    />
    <input
      type="button"
      class="button_primary button_var_1 button_right-spacing"
      value="Page Sections and Containers"
      (click)="jumpToSection('divSections')"
    />
    <input
      type="button"
      class="button_primary button_var_1 button_right-spacing"
      value="Tables"
      (click)="jumpToSection('divTables')"
    />
    <input
      type="button"
      class="button_primary button_var_1 button_right-spacing"
      value="Buttons"
      (click)="jumpToSection('divButtons')"
    />
    <input
      type="button"
      class="button_primary button_var_1 button_right-spacing"
      value="Form Controls"
      (click)="jumpToSection('divInputs')"
    />

    <!-- TODO: 
        Page / container widths
        - including responsive width cutoffs
        -->
  </div>

  <div id="divTypography" class="section">
    <h2>Typography</h2>

    <table>
      <tr>
        <td>
          <p>
            Headers -
            <span style="font-family: 'Playfair Display'"
              >Playfair Display</span
            >
          </p>
          <p>
            Body - <span style="font-family: 'Roboto', sans-serif">Roboto</span>
          </p>
          <p>
            Buttons -
            <span style="font-family: 'Roboto', sans-serif">Roboto</span>
          </p>
          <p>
            Form labels -
            <span style="font-family: 'Raleway', sans-serif"
              >Raleway, sans-serif</span
            >
          </p>
          <p>
            Code -
            <span style="font-family: 'Courier New', Courier, monospace"
              >Courier New, Courier, monospace</span
            >
          </p>
        </td>
      </tr>
    </table>
  </div>

  <div id="divColors" class="section">
    <h2>Colors</h2>
  </div>

  <div id="divIconography" class="section">
    <app-style-iconography></app-style-iconography>
  </div>

  <div id="divLoadingSpinners" class="section">
    <app-style-loading-spinners></app-style-loading-spinners>
  </div>

  <div id="divSections" class="section">
    <app-style-page-containers></app-style-page-containers>
  </div>

  <div id="divTables" class="section">
    <h4>Tables</h4>
  </div>

  <div id="divButtons" class="section">
    <app-style-buttons></app-style-buttons>
  </div>

  <div id="divInputs" class="section">
    <app-style-form-controls></app-style-form-controls>
  </div>
</div>
